let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b6JBs")).then(() => parcelRequire('g3Wvh'));